import { Component, OnInit } from '@angular/core';
import { FormControl } from '@angular/forms';
import { FieldType } from '@ngx-formly/core';

@Component({
  selector: "formly-color-picker",
  template: `
    <div class="color-wrapper">
      <label class="color-label">{{ to.label }}</label>
      <input
        type="color"
        [formControl]="control"
        class="color-input"
        (input)="onColorInput($event)"
      />
    </div>
  `,
  styles: [
    `
      .color-wrapper {
        display: flex;
        align-items: center;
        justify-content: space-between; /* label left, input right */
        width: 100%;
        padding: 4px 0;
        font-family: "Poppins" !important;
      }
      .color-label {
        font-size: 10px;
        font-weight: 600;
        color: #101d42;
        font-family: "Poppins" !important;
      }
      .color-input {
        width: 30px;
        height: 28px;
        border: 1px solid #ccc;
        border-radius: 4px;
        cursor: pointer;
        padding: 0;
      }
      .color-input::-webkit-color-swatch-wrapper {
        padding: 0;
      }
      .color-input::-webkit-color-swatch {
        border: none;
        border-radius: 4px;
      }
    `,
  ],
})
export class ColorPickerTypeComponent extends FieldType implements OnInit {
  get control(): FormControl {
    return this.formControl as FormControl;
  }
  ngOnInit() {
    // If external onChange provided in templateOptions, call it when the value changes
    this.formControl.valueChanges.subscribe((value) => {
      if (this.to && typeof this.to["onChange"] === "function") {
        // Pass (value, field) similar to other custom types
        // Pass (value, field) similar to other custom types
        this.to["onChange"](value, this.field);
      }
    });
  }

  onColorInput(event: Event) {
    const value = (event.target as HTMLInputElement).value;
    // Update Formly model (this also triggers valueChanges)
    this.formControl.setValue(value, { emitEvent: true });
  }
}
